import { fetchV3 } from "./client";

export const listMemberships = (filters = {}, { limit = 30 } = {}) =>
  fetchV3({
    url: "memberships/",
    body: { ...filters, limit },
  });

export const getMembership = (membershipUuid) =>
  fetchV3({ url: `memberships/${membershipUuid}/` });

export const createMembership = (payload) =>
  fetchV3({
    url: "memberships/",
    method: "POST",
    body: payload,
  });

export const updateMembership = (membershipUuid, payload) =>
  fetchV3({
    url: `memberships/${membershipUuid}/`,
    method: "PATCH",
    body: payload,
  });

export const listMembershipsForPatient = (payload) => {
  const params = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString() ? `?${params.toString()}` : "";
  return fetchV3({
    url: "memberships/for_patient",
    query,
  });
};

export const listFutureRequestsForMembership = ({
  membershipUuid,
  payload,
}) =>
  fetchV3({
    url: "service-requests/future_request",
    body: {
      membership: membershipUuid,
      ...payload,
    },
  });
